import { render, staticRenderFns } from "./ConfigureOrderModal.vue?vue&type=template&id=5208b65e&scoped=true"
import script from "./ConfigureOrderModal.vue?vue&type=script&lang=js"
export * from "./ConfigureOrderModal.vue?vue&type=script&lang=js"
import style0 from "./ConfigureOrderModal.vue?vue&type=style&index=0&id=5208b65e&prod&lang=css"
import style1 from "./ConfigureOrderModal.vue?vue&type=style&index=1&id=5208b65e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5208b65e",
  null
  
)

export default component.exports